import Http from '@/http/bhiotrack';
import { serialize } from '@/utils';

export default {
  async createPaymentMethod(data) {
    const response = await Http.post('/payment-method', data);
    return response.data;
  },

  async getPaymentMethods(params) {
    const response = await Http.get(`/payment-method${serialize(params)}`);
    return response.data;
  },

  async updatePaymentMethod(paymentMethodId, data) {
    const response = await Http.put(`/payment-method/${paymentMethodId}`, data);
    return response.data;
  },

  async deletePaymentMethod(paymentMethodId, iuguUserId) {
    const response = await Http.delete(`/payment-method/${paymentMethodId}/${iuguUserId}`);
    return response.data;
  },
};
